import React, { useEffect, useState } from "react";
import "./AdminProjectFolder.css";
import bfLogo from "../assets/bf_logo.png";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

/* ===== FIREBASE ===== */
import { db, auth } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

const PER_PAGE = 5;

/* ===== DATE FORMAT ===== */
const formatDate = (ts) => {
  if (!ts) return "-";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return `${String(d.getDate()).padStart(2, "0")}.${String(
    d.getMonth() + 1
  ).padStart(2, "0")}.${d.getFullYear()}`;
};

export default function AdminProjectFolder() {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const { t } = useTranslation();

  const [weeks, setWeeks] = useState([]);
  const [page, setPage] = useState(1);
  const [slideDir, setSlideDir] = useState("next");
  const [currentUser, setCurrentUser] = useState(null);

  /* 1. STEBIME PRISIJUNGIMĄ */
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
      } else {
        navigate("/admin/login");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  /* 2. KRAUNAME DUOMENIS (Suderinta su Sub-Admin logika) */
  useEffect(() => {
    if (!projectId || !currentUser) return;

    const load = async () => {
      try {
        // A. Sužinome Master ID
        const userRef = doc(db, "users", currentUser.uid);
        const userSnap = await getDoc(userRef);
        
        let masterId = currentUser.uid;
        if (userSnap.exists()) {
          const uData = userSnap.data();
          masterId = uData.belongsTo || currentUser.uid;
        }

        // B. Krauname konkretų projektą
        const docRef = doc(db, "projects", projectId);
        const snap = await getDoc(docRef);

        if (snap.exists()) {
          const data = snap.data();

          // C. PATIKRA: Ar projektas priklauso tavo komandai (Master ID)?
          if (data.adminId === masterId) {
            const list = [{
              id: snap.id,
              kw: data.kw,
              from: data.createdAt,
              version: "v1" 
            }];
            setWeeks(list);
          } else {
            console.error("Access denied: Not your project");
          }
        }
      } catch (err) {
        console.error("Klaida kraunant projekto aplanką:", err);
      }
    };

    load();
  }, [projectId, currentUser]);

  const totalPages = Math.max(1, Math.ceil(weeks.length / PER_PAGE));
  const start = (page - 1) * PER_PAGE;
  const visible = weeks.slice(start, start + PER_PAGE);

  const next = () => {
    if (page < totalPages) {
      setSlideDir("next");
      setPage(p => p + 1);
    }
  };

  const prev = () => {
    if (page > 1) {
      setSlideDir("prev");
      setPage(p => p - 1);
    }
  };

  return (
    <div className="project-folder-container">
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← {t('back')}
      </button>

      <div className="project-folder-content">
        <img src={bfLogo} alt="BF" className="project-logo" />
        <h1 className="project-title">{t('project')}</h1>

        <div className={`project-files-wrapper ${slideDir}`} key={page}>
          {visible.map((w, i) => (
            <div key={i} className="file-card">
              <div className="file-main">
                <div className="file-title">
                  KW {w.kw}
                </div>
                <div className="file-sub">
                  {t('save')}: {formatDate(w.from)}
                </div>
              </div>

              <button
                className="open-btn"
                onClick={() =>
                  navigate(
                    `/admin/projects/${w.id}/${w.kw}/v1`
                  )
                }
              >
                {t('open') || "Atidaryti"}
              </button>
            </div>
          ))}

          {weeks.length === 0 && (
            <div style={{ textAlign: "center", opacity: 0.6, marginTop: "20px" }}>
              {t('no_data') || "No data available"}
            </div>
          )}
        </div>

        {totalPages > 1 && (
          <div className="project-pagination">
            <button onClick={prev}>
              <ChevronLeft size={18} />
            </button>
            <span>{page} / {totalPages}</span>
            <button onClick={next}>
              <ChevronRight size={18} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}